// LifeCool — scripts propios (prefijo mt-)
// Varias secciones incluyen esta misma etiqueta <script>; esta protección evita
// que se inicialice más de una vez si el archivo aparece repetido en la página.
if (!window.__mtScriptsInitialized) {
  window.__mtScriptsInitialized = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCarruselProducto();
    initZoomProducto();
    initVariantesProducto();
    initFaqAcordeon();
    initBarraFijaProducto();
    initCheckoutDirecto();
    initCantidadProducto();
    initBarraFijaCOD();
    initVideoProducto();
    initCarruselResenas();
    initCarruselTestimonios();
    initAntesDespues();
    initConfianzaCod();
    initCaracteristicas();
  });
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initCarruselProducto() {
  var carrusel = document.querySelector('[data-mt-carrusel]');
  if (!carrusel) return;
  var track = carrusel.querySelector('[data-mt-carrusel-track]');
  var slides = carrusel.querySelectorAll('.mt-carrusel-slide');
  var dots = carrusel.querySelectorAll('[data-mt-carrusel-dot]');
  var prev = carrusel.querySelector('[data-mt-carrusel-prev]');
  var next = carrusel.querySelector('[data-mt-carrusel-next]');
  if (!track || slides.length < 2) return;

  var indice = 0;

  function ir(i) {
    indice = Math.max(0, Math.min(slides.length - 1, i));
    track.style.transform = 'translateX(-' + (indice * 100) + '%)';
    dots.forEach(function (d, di) { d.classList.toggle('mt-carrusel-dot--activo', di === indice); });
  }

  if (prev) prev.addEventListener('click', function () { ir(indice - 1 < 0 ? slides.length - 1 : indice - 1); });
  if (next) next.addEventListener('click', function () { ir(indice + 1 >= slides.length ? 0 : indice + 1); });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { ir(parseInt(d.getAttribute('data-index'), 10) || 0); });
  });

  track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';

  var startX = null;
  var deltaX = 0;
  track.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
    deltaX = 0;
    track.style.transition = 'none';
  }, { passive: true });
  track.addEventListener('touchmove', function (e) {
    if (startX === null) return;
    deltaX = e.touches[0].clientX - startX;
    track.style.transform = 'translateX(calc(-' + (indice * 100) + '% + ' + deltaX + 'px))';
  }, { passive: true });
  track.addEventListener('touchend', function () {
    track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
    if (deltaX < -50) ir(indice + 1 >= slides.length ? indice : indice + 1);
    else if (deltaX > 50) ir(indice - 1 < 0 ? indice : indice - 1);
    else ir(indice);
    startX = null;
    deltaX = 0;
  });
}

function initZoomProducto() {
  var overlay = document.querySelector('[data-mt-zoom-overlay]');
  if (!overlay) return;
  var img = overlay.querySelector('[data-mt-zoom-imagen]');
  var cerrar = overlay.querySelector('[data-mt-zoom-cerrar]');
  var disparadores = document.querySelectorAll('[data-mt-zoom-trigger], [data-mt-zoom-abrir]');

  function abrirCon(src) {
    if (!src || !img) return;
    img.src = src;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  function cerrarOverlay() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  disparadores.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var carrusel = document.querySelector('[data-mt-carrusel]');
      var activo = carrusel ? carrusel.querySelector('.mt-carrusel-slide[data-full]') : null;
      var slides = carrusel ? carrusel.querySelectorAll('.mt-carrusel-slide[data-full]') : [];
      var track = carrusel ? carrusel.querySelector('[data-mt-carrusel-track]') : null;
      var src = el.getAttribute('data-full');
      if (!src && track && slides.length) {
        var transform = track.style.transform || '';
        var match = /-([0-9]+)%/.exec(transform);
        var idx = match ? Math.round(parseInt(match[1], 10) / 100) : 0;
        src = slides[idx] ? slides[idx].getAttribute('data-full') : (activo && activo.getAttribute('data-full'));
      }
      abrirCon(src);
    });
  });
  if (cerrar) cerrar.addEventListener('click', cerrarOverlay);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) cerrarOverlay();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarOverlay();
  });
}

function initBarraFijaProducto() {
  var barra = document.querySelector('[data-mt-barra-fija]');
  var botonReal = document.querySelector('[data-mt-boton-comprar]');
  if (!barra || !botonReal) return;
  var botonBarra = barra.querySelector('[data-mt-barra-fija-boton]');

  if (botonBarra) {
    botonBarra.addEventListener('click', function () {
      botonReal.click();
    });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pasadoHaciaArriba = entry.boundingClientRect.top < 0;
        barra.classList.toggle('mt-barra-fija--visible', !entry.isIntersecting && pasadoHaciaArriba);
      });
    }, { threshold: 0 });
    obs.observe(botonReal);
  }
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  var selects = form.querySelectorAll('[data-mt-opcion]');
  if (!dataEl || !selects.length) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var comparaEl = document.querySelector('[data-mt-precio-comparado]');
  var botonEl = form.querySelector('[data-mt-boton-comprar]');

  function opcionesSeleccionadas() {
    var valores = [];
    selects.forEach(function (s) { valores.push(s.value); });
    return valores;
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl && variante.price_formatted) precioEl.textContent = variante.price_formatted;
    if (comparaEl) {
      if (variante.compare_at_price_formatted) {
        comparaEl.textContent = variante.compare_at_price_formatted;
        comparaEl.style.display = '';
      } else {
        comparaEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (variante.available) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-texto-disponible') || botonEl.textContent;
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initFaqAcordeon() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;

  function cerrar(item) {
    var respuesta = item.querySelector('.mt-faq-respuesta');
    item.classList.remove('mt-faq--abierta');
    if (respuesta) respuesta.style.maxHeight = '0px';
  }
  function abrir(item) {
    var respuesta = item.querySelector('.mt-faq-respuesta');
    item.classList.add('mt-faq--abierta');
    if (respuesta) respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
  }

  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-faq--abierta');
      items.forEach(cerrar);
      if (!abierta) abrir(item);
    });
  });

  window.addEventListener('resize', function () {
    items.forEach(function (item) {
      if (item.classList.contains('mt-faq--abierta')) abrir(item);
    });
  });
}

function initConfianzaCod() {
  var items = document.querySelectorAll('[data-mt-confianza-item]');
  if (!items.length) return;

  function actualizar(item) {
    var detalle = item.querySelector('.mt-confianza-detalle');
    var abierta = item.classList.contains('mt-confianza--abierta');
    if (detalle) detalle.style.maxHeight = abierta ? detalle.scrollHeight + 'px' : '0px';
  }

  items.forEach(function (item) {
    var boton = item.querySelector('[data-mt-confianza-toggle]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      item.classList.toggle('mt-confianza--abierta');
      actualizar(item);
    });
  });

  window.addEventListener('resize', function () {
    items.forEach(function (item) {
      if (item.classList.contains('mt-confianza--abierta')) actualizar(item);
    });
  });
}

function initCaracteristicas() {
  var items = document.querySelectorAll('[data-mt-caracteristica-item]');
  if (!items.length) return;

  function actualizar(item) {
    var detalle = item.querySelector('.mt-caracteristica-detalle');
    var abierta = item.classList.contains('mt-caracteristica--abierta');
    if (detalle) detalle.style.maxHeight = abierta ? detalle.scrollHeight + 'px' : '0px';
  }

  items.forEach(function (item) {
    var boton = item.querySelector('[data-mt-caracteristica-toggle]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      item.classList.toggle('mt-caracteristica--abierta');
      actualizar(item);
    });
  });

  window.addEventListener('resize', function () {
    items.forEach(function (item) {
      if (item.classList.contains('mt-caracteristica--abierta')) actualizar(item);
    });
  });
}

function initCheckoutDirecto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var boton = form.querySelector('[data-mt-boton-comprar]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (boton) {
      boton.disabled = true;
      boton.dataset.textoOriginal = boton.textContent;
      boton.textContent = 'Procesando...';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          if (boton) {
            boton.disabled = false;
            boton.textContent = boton.dataset.textoOriginal || boton.textContent;
          }
          alert(data.description || 'No se pudo agregar el producto. Intenta de nuevo.');
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        form.submit();
      });
  });
}

function initCantidadProducto() {
  var input = document.querySelector('[data-mt-cantidad-input]');
  var menos = document.querySelector('[data-mt-cantidad-menos]');
  var mas = document.querySelector('[data-mt-cantidad-mas]');
  if (!input) return;

  function normalizar() {
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    input.value = val;
    return val;
  }

  if (menos) {
    menos.addEventListener('click', function () {
      input.value = Math.max(1, normalizar() - 1);
    });
  }
  if (mas) {
    mas.addEventListener('click', function () {
      input.value = normalizar() + 1;
    });
  }
  input.addEventListener('change', normalizar);
  input.addEventListener('blur', normalizar);
}

function initBarraFijaCOD() {
  var barra = document.querySelector('[data-mt-barra-fija]');
  var botonReal = document.querySelector('[data-mt-cod-abrir]');
  if (!barra || !botonReal) return;
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var pasadoHaciaArriba = entry.boundingClientRect.top < 0;
      barra.classList.toggle('mt-barra-fija--visible', !entry.isIntersecting && pasadoHaciaArriba);
    });
  }, { threshold: 0 });
  obs.observe(botonReal);
}

function initVideoProducto() {
  var video = document.querySelector('[data-mt-video-producto]');
  if (!video) return;

  function intentarReproducir() {
    var promesa = video.play();
    if (promesa && promesa.catch) promesa.catch(function () {});
  }

  intentarReproducir();

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) intentarReproducir();
      });
    }, { threshold: 0.25 });
    obs.observe(video);
  }

  ['touchstart', 'click', 'scroll'].forEach(function (evento) {
    document.addEventListener(evento, intentarReproducir, { once: true, passive: true });
  });
}

function initCarruselResenas() {
  var carruseles = document.querySelectorAll('[data-mt-resena-carrusel]');
  if (!carruseles.length) return;

  carruseles.forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-mt-resena-track]');
    var slides = carrusel.querySelectorAll('.mt-resena-carrusel__slide');
    var dots = carrusel.querySelectorAll('[data-mt-resena-dot]');
    var prev = carrusel.querySelector('[data-mt-resena-prev]');
    var next = carrusel.querySelector('[data-mt-resena-next]');
    if (!track || slides.length < 2) return;

    var indice = 0;

    function ir(i) {
      indice = Math.max(0, Math.min(slides.length - 1, i));
      track.style.transform = 'translateX(-' + (indice * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('mt-carrusel-dot--activo', di === indice); });
    }

    if (prev) prev.addEventListener('click', function () { ir(indice - 1 < 0 ? slides.length - 1 : indice - 1); });
    if (next) next.addEventListener('click', function () { ir(indice + 1 >= slides.length ? 0 : indice + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { ir(parseInt(d.getAttribute('data-index'), 10) || 0); });
    });

    track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';

    var startX = null;
    var deltaX = 0;
    track.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      startX = e.touches[0].clientX;
      deltaX = 0;
      track.style.transition = 'none';
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      e.stopPropagation();
      if (startX === null) return;
      deltaX = e.touches[0].clientX - startX;
      track.style.transform = 'translateX(calc(-' + (indice * 100) + '% + ' + deltaX + 'px))';
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      e.stopPropagation();
      track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
      if (deltaX < -50) ir(indice + 1 >= slides.length ? indice : indice + 1);
      else if (deltaX > 50) ir(indice - 1 < 0 ? indice : indice - 1);
      else ir(indice);
      startX = null;
      deltaX = 0;
    });
  });
}

function initCarruselTestimonios() {
  var carrusel = document.querySelector('[data-mt-testimonios-carrusel]');
  if (!carrusel) return;
  var track = carrusel.querySelector('[data-mt-testimonios-track]');
  var slides = carrusel.querySelectorAll('.mt-testimonio-slide');
  var dots = carrusel.querySelectorAll('[data-mt-testimonios-dot]');
  var prev = carrusel.querySelector('[data-mt-testimonios-prev]');
  var next = carrusel.querySelector('[data-mt-testimonios-next]');
  if (!track || slides.length < 2) return;

  var indice = 0;

  function ir(i) {
    indice = Math.max(0, Math.min(slides.length - 1, i));
    track.style.transform = 'translateX(-' + (indice * 100) + '%)';
    dots.forEach(function (d, di) { d.classList.toggle('mt-testimonio-dot--activo', di === indice); });
  }

  if (prev) prev.addEventListener('click', function () { ir(indice - 1 < 0 ? slides.length - 1 : indice - 1); });
  if (next) next.addEventListener('click', function () { ir(indice + 1 >= slides.length ? 0 : indice + 1); });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { ir(parseInt(d.getAttribute('data-index'), 10) || 0); });
  });

  track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';

  var startX = null;
  var deltaX = 0;
  track.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
    deltaX = 0;
    track.style.transition = 'none';
  }, { passive: true });
  track.addEventListener('touchmove', function (e) {
    if (startX === null) return;
    deltaX = e.touches[0].clientX - startX;
    track.style.transform = 'translateX(calc(-' + (indice * 100) + '% + ' + deltaX + 'px))';
  }, { passive: true });
  track.addEventListener('touchend', function () {
    track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
    if (deltaX < -50) ir(indice + 1 >= slides.length ? indice : indice + 1);
    else if (deltaX > 50) ir(indice - 1 < 0 ? indice : indice - 1);
    else ir(indice);
    startX = null;
    deltaX = 0;
  });

  var autoplay = setInterval(function () { ir(indice + 1 >= slides.length ? 0 : indice + 1); }, 6000);
  carrusel.addEventListener('mouseenter', function () { clearInterval(autoplay); });
  carrusel.addEventListener('touchstart', function () { clearInterval(autoplay); }, { passive: true, once: true });
}

function initAntesDespues() {
  var sliders = document.querySelectorAll('[data-mt-antes-despues]');
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var antes = slider.querySelector('[data-mt-ad-antes]');
    var handle = slider.querySelector('[data-mt-ad-handle]');
    if (!antes || !handle) return;

    var dragging = false;

    function posicionar(porcentaje) {
      porcentaje = Math.max(0, Math.min(100, porcentaje));
      antes.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
      handle.style.left = porcentaje + '%';
      slider.setAttribute('aria-valuenow', Math.round(porcentaje));
    }

    function porcentajeDesdeX(clientX) {
      var rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function onMove(clientX) {
      posicionar(porcentajeDesdeX(clientX));
    }

    slider.addEventListener('mousedown', function (e) {
      dragging = true;
      onMove(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      onMove(e.clientX);
    });
    window.addEventListener('mouseup', function () { dragging = false; });

    slider.addEventListener('touchstart', function (e) {
      dragging = true;
      onMove(e.touches[0].clientX);
    }, { passive: true });
    slider.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      onMove(e.touches[0].clientX);
    }, { passive: true });
    slider.addEventListener('touchend', function () { dragging = false; });

    slider.addEventListener('keydown', function (e) {
      var actual = parseFloat(slider.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { posicionar(actual - 5); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { posicionar(actual + 5); e.preventDefault(); }
    });
  });
}
